import { Button } from '@mgh-app/component-library';
import {
  borderColor,
  borderWidth,
  combineCls,
  display,
  flexDirection,
  fontSize,
  gap,
  height,
  justifyContent,
  overflow,
  padding,
  tailwindClassNameConvertNegative,
  textAlign,
  TMargin,
  twCls,
  whitespace,
  width,
} from 'style';

export interface InformationalProps {
  title: string;
  children: JSX.Element;
  onCancel: () => void;
}

export const Informational = ({ title, children, onCancel }: InformationalProps): JSX.Element => {
  return (
    <div
      className={combineCls(twCls(display('flex'), flexDirection('flex-col'), height('h-full')))}
    >
      <div
        className={combineCls(
          twCls(
            height('h-max'),
            display('flex'),
            flexDirection('flex-col'),
            overflow('overflow-hidden'),
            padding('pt-1'),
          ),
        )}
      >
        <div
          className={twCls(
            overflow('overflow-y-auto'),
            display('flex'),
            flexDirection('flex-col'),
            gap('gap-8'),
            whitespace('whitespace-pre-wrap'),
            padding('pb-6', 'pt-4'),
            fontSize('text-sm'),
          )}
        >
          <h2 className={twCls(width('w-full'), textAlign('text-center'), fontSize('text-base'))}>
            {title}
          </h2>
          {children}
        </div>
      </div>
      <div
        className={combineCls(
          twCls(
            padding('pt-2'),
            height('h-fit'),
            display('flex'),
            justifyContent('justify-center'),
            borderWidth('border-t'),
            borderColor('border-grey-900'),
            tailwindClassNameConvertNegative<TMargin>('-mx-4'),
          ),
        )}
      >
        <Button className={twCls(width('w-36'))} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};
